export default __webpack_public_path__ + "static/media/success-iphone-logo.a383f3cc.svg";